<div *ngIf="devicesOfV2Cascade.length > 0; else basicTemplate" class="flex flex-col gap-[24px]">
  <app-device-overlay
    *ngFor="let device of devicesOfV2Cascade"
    [device]="device"
    [showSystemDetails]="true"
    [isV2Cascade]="true"
    title="{{
      device.shortDeviceName ||
        '+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' + device.deviceType.toUpperCase()
        | translate
    }}"
  >
  </app-device-overlay>
</div>

<ng-container *ngIf="!(isVicareThermostatMode$ | async)">
  <ng-container *ngIf="gatewayStore.getVitotrolDevices$ | async as vitotrolDevices">
    <div *ngIf="vitotrolDevices.length" class="remote-controllers">
      <ng-container>
        <app-feature-list-container>
          <div class="flex flex-col gap-[24px]">
            <h3>{{ '+INSTALLATIONS.INSTALLATION.REMOTE_CONTROLLER.TITLE' | translate }}</h3>
            <div class="grid xs:grid-cols-1 sm:grid-cols-1 grid-cols-2 gap-4">
              <div class="remote-controller" *ngFor="let device of vitotrolDevices">
                <app-remote-controller-overlay
                  [showTitleAndAction]="true"
                  [device]="device"
                  (confirmDelete)="deleteVitotrol($event)"
                ></app-remote-controller-overlay>
              </div>
            </div>
          </div>
        </app-feature-list-container>
      </ng-container>
    </div>
    <div
      *ngIf="installationFeaturesStore.canAddVitotrolToInstallation$ | async"
      class="add-vitotrol-btn"
    >
      <button
        data-at-reboot-device-btn
        mat-raised-button
        color="primary"
        class="mt-[16px] py-2 btn-jumbotron"
        gtm="onOpen"
        gtmAction="Add new remote controller"
        gtmCategory="system"
        (click)="onAddDevice()"
      >
        {{ '+SRC_COMMISSIONINGV2.ADD_REMOTE_CONTROLLER_BUTTON' | translate }}
      </button>
    </div>
  </ng-container>
</ng-container>

<ng-template #basicTemplate>
  <app-device-overlay [showSystemDetails]="true"></app-device-overlay>
  <app-sequencing-strategy></app-sequencing-strategy>
</ng-template>
